module.exports = require('./lib/sync');